export default "__VITE_ASSET__CJAyrdC2__"